module.exports = __webpack_public_path__ + "img/RS-J-6.ca67482e.svg";